<template>
  <!-- <hand-off /> -->
  <HandOff />

</template>

<script>

import HandOff from "@/components/3pl/Operations/Dispatch/handoff/HandOff.vue";

export default {
  components: {
    HandOff,
  },
};
</script>

<style></style>
